import { MaterialFormType, TotalDataType } from '../../components/_templates/seller/SellerDetailContent/types';
import { returnNumberWithComma } from '@utils/regex';

/**
 *  입력받은 form으로 자재별 총계를 계산하는 hook
 */
export const parseCalcTotalData = (materialForm: MaterialFormType[], ko: boolean) => {
  const TOTAL = ko ? '총합' : 'Total';

  const totalData: TotalDataType = {
    PIPE: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    VALVE: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    FLANGE: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    FITTING: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    SECTION: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    PLATE: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    'BOLT/NUT': { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    GASKET: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    FORGING: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    TUBE: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
    [TOTAL]: { quantity: 0, supply_price: 0, vat: 0, total_price: 0 },
  };

  // 빈값 row 제거
  const validMaterialForm = materialForm.filter((item) => item.total_price);
  validMaterialForm.map((item) => {
    const { product_type, quantity, unit_price } = item;
    const target = totalData[product_type];
    const total = totalData[TOTAL];

    target.quantity += quantity;
    target.supply_price += quantity * unit_price;
    target.vat = Math.round(target.supply_price / 10);
    target.total_price = target.supply_price + target.vat;

    total.quantity += quantity;
    total.supply_price += quantity * unit_price;
    total.vat = Math.round(total.supply_price / 10);
    total.total_price = total.supply_price + total.vat;
  });

  const won = ko ? '원' : ' KRW';
  // table data 형식으로
  return Object.entries(totalData)
    .filter(([, { total_price }]) => total_price)
    .map(([type, { quantity, supply_price, vat, total_price }]) => ({
      type,
      quantity: returnNumberWithComma(quantity),
      supply_price: returnNumberWithComma(supply_price) + won,
      vat: returnNumberWithComma(vat) + won,
      total_price: returnNumberWithComma(total_price) + won,
    }));
};
